import { useRemoteImage } from '@gem/modules/remote-storage';

import { LINK_PREVIEW_MAX_SIZE } from 'APP/constants/messages';
import {
  IImageResizerLocalStore,
  useImageResizer,
} from 'APP/main/hooks/useImageResizer/useImageResizer';
import { TextPayload } from 'STORE/Messages/Message/Payload/TextPayload/TextPayload';

interface IUseLinkPreviewPresenterProps {
  data: TextPayload['linkPreview'];
}

interface ILinkPreviewPresenter {
  resizedImage: IImageResizerLocalStore;
  isYouTubeVideo: boolean;
  isImagePreview: boolean;
}

export const useLinkPreviewPresenter = ({
  data,
}: IUseLinkPreviewPresenterProps): ILinkPreviewPresenter => {
  const { image, video, imageGraphicSize } = data;
  const { src } = useRemoteImage({ url: image?.url });
  const isYouTubeVideo = video?.videoId && video?.type === 'youtube';
  const resizedImage = useImageResizer({
    url: src,
    maxWidth: LINK_PREVIEW_MAX_SIZE.width,
    maxHeight: LINK_PREVIEW_MAX_SIZE.height,
    graphicSize: imageGraphicSize || image?.graphicSize || { width: 0, height: 0 },
  });

  return {
    resizedImage,
    isYouTubeVideo,
    isImagePreview: image?.url && !isYouTubeVideo,
  };
};
